import { UsageProgressProviderRowProps } from '../models/usage-progress-card-props';

export const UsageProgressProviderRow: React.FC<UsageProgressProviderRowProps> = ({
    media,
    name,
    description,
    action,
}) => (
    <div className="flex items-center gap-3 rounded-lg border border-border py-2 px-4">
        {media}
        <div className="flex min-w-0 flex-1 flex-col">
            <div className="text-body-md font-semibold">{name}</div>
            {description && <div className="text-body-sm text-text-subdued">{description}</div>}
        </div>
        {action}
    </div>
);
